// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10653251","885":"55c4b7bc"}[chunkId] + ".chunk.js";
};